import { UserLayout, TabLayout, RouteView, BlankLayout, PageView } from '@/components/layouts'

/**
 * 走菜单，走权限控制
 * @type {[null,null]}
 */
export const asyncRouterMap = [
  {
    path: '/',
    name: 'dashboard',
    component: TabLayout,
    meta: { title: '首页' },
    redirect: '/dashboard/analysis',
    children: [],
  },
  {
    path: '/',
    name: 'testMenu',
    component: TabLayout,
    meta: { title: '测试菜单' },
    redirect: '/test/menu',
    children: [],
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/searchResult',
    name: 'searchResult',
    component: TabLayout,
    meta: { title: '搜索页' },
    redirect: '/searchResult/result',
    children: [
      {
        path: 'result',
        component: () => import('@views/tyrz/SearchResult'),
        meta: { title: '搜索结果页' },
      },
    ],
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login'),
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register'),
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult'),
      },
      {
        path: 'alteration',
        name: 'alteration',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Alteration'),
      },
    ],
  },
  {
    path: '/examples',
    component: TabLayout,
    redirect: '/examples/index',
    children: [
      {
        path: 'index',
        name: 'examples-index',
        meta: {
          title: '测试路由',
        },
        component: () => import('@/views/examples/index'),
      },
      /* {
        path: 'action_test_edit',
        name: 'action_test_edit',
        meta: {
          title:'测试路由11'
        },
        component: () => import('@/views/examples/modules/test_edit')
      } */
      {
        path: 'test-table',
        name: 'testTable',
        meta: {
          title: '父子表格分页问题',
        },
        component: () => import('@/views/examples/父子表格分页.vue'),
      },
    ],
  },
  {
    path: '/tyrz/biIndex',
    meta: {
      title: '信e采数据平台',
    },
    component: () => import(/* webpackChunkName: "fail" */ '@/views/tyrz/biIndex'),
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
  },
]
